//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { cloneDeep, get, set } from 'lodash';

import { SamplingCampaignRequest } from '@apis/campaign-requests/sampling/campaign-requests/samplingCampaignRequestsApiModel';

export const mergeDirtySamplingCampaignFields = (
  serverValues: SamplingCampaignRequest,
  currentValues: SamplingCampaignRequest,
  dirtyFields: unknown,
): SamplingCampaignRequest | undefined => {
  if (
    currentValues.campaignRequestId !== serverValues.campaignRequestId ||
    !dirtyFields ||
    typeof dirtyFields !== 'object'
  ) {
    return undefined;
  }

  const dirtyEntries = Object.entries(dirtyFields).filter(
    ([field]) => field !== 'products',
  );
  if (dirtyEntries.length === 0) {
    return undefined;
  }

  const mergedValues = cloneDeep(serverValues);
  const preserveDirtyFields = (fields: unknown, path: string[]) => {
    if (fields === true) {
      set(mergedValues, path, get(currentValues, path));
    } else if (fields && typeof fields === 'object') {
      Object.entries(fields).forEach(([field, value]) => {
        preserveDirtyFields(value, [...path, field]);
      });
    }
  };
  dirtyEntries.forEach(([field, value]) => {
    preserveDirtyFields(value, [field]);
  });

  return mergedValues;
};
